const COMPANY_INFO = 'CI';
const VETERAN_INFO = 'VI';
const BUSINESS_STRUCTURE = 'BS';
const CERTIFICATIONS = 'CER';
const FINANCES = 'FIN';
const BANKING = 'BNK';
const TAXES = 'TAX';
const EQUIPMENT = 'EQ';
const ARTICLES = 'ART';
const DECLARATION = 'DEC';
const PREQUALIFICATION = 'PRE';

export default {
    COMPANY_INFO,
    VETERAN_INFO,
    BUSINESS_STRUCTURE,
    CERTIFICATIONS,
    FINANCES,
    BANKING,
    TAXES,
    EQUIPMENT,
    ARTICLES,
    DECLARATION,
    PREQUALIFICATION
};


// WEBPACK FOOTER //
// ./src/areas/shared/consts/TooltipCategory.js